/* tslint:disable */
/* eslint-disable */
import { NgModule, ModuleWithProviders, SkipSelf, Optional } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiConfiguration, ApiConfigurationParams } from './api-configuration';

import { AsdSicherheitsbriefControllerService } from './services/asd-sicherheitsbrief-controller.service';

/**
 * Module that provides all services and configuration.
 */
@NgModule({
  imports: [],
  exports: [],
  declarations: [],
  providers: [
    AsdSicherheitsbriefControllerService,
    ApiConfiguration
  ],
})
export class MyasiDocumentAsdModule {
  static forRoot(params: ApiConfigurationParams): ModuleWithProviders<MyasiDocumentAsdModule> {
    return {
      ngModule: MyasiDocumentAsdModule,
      providers: [
        {
          provide: ApiConfiguration,
          useValue: params
        }
      ]
    }
  }

  constructor( 
    @Optional() @SkipSelf() parentModule: MyasiDocumentAsdModule,
    @Optional() http: HttpClient
  ) {
    if (parentModule) {
      throw new Error('MyasiDocumentAsdModule is already loaded. Import in your base AppModule only.');
    }
    if (!http) {
      throw new Error('You need to import the HttpClientModule in your AppModule! \n' +
      'See also https://github.com/angular/angular/issues/20575');
    }
  }
}
